import type { ExpandedLayout, FormFactor } from '../../config/constants';

interface ResolveExpandedLayoutOptions {
    enableCopilotLayout: boolean;
    formFactor?: FormFactor;
    isFormAssistant?: boolean;
    storedLayout: ExpandedLayout;
}

export function resolveExpandedLayout({
    enableCopilotLayout,
    formFactor = 'default',
    isFormAssistant = false,
    storedLayout,
}: ResolveExpandedLayoutOptions): ExpandedLayout {
    if (isFormAssistant || formFactor === 'copilot') {
        return 'copilot';
    }

    if (!enableCopilotLayout) {
        return 'expanded';
    }

    return storedLayout;
}
